// España
export default {
	status: {
		All: "Todos",
		Pending: "Pendiente",
		Frozen: "Congelado",
		Completed: "Completado",
		Undone: "No realizado"
	},
	TotalAmount: "Cantidad total",
	Profit: "Beneficio",
	Expire: "Expirar"
};
